/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import AppRouter from '../../router/AppRouter/AppRouter';
import styles from './styles';

// sample layout, change this as per your app's need
const AppLayout = ({
  classes: { header, header_link, header_language_selector, content, layoutContainer, footer },
  t,
}) => (
  <React.Fragment>
    <div className={layoutContainer}>
      <div className={content}>
        <div>{AppRouter()}</div>
      </div>
    </div>
  </React.Fragment>
);

AppLayout.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(AppLayout));
